import { createAsyncThunk } from "@reduxjs/toolkit"
import { formDataPost, post } from "helpers/api_helper"
import {
  CUSTOM_BATCH_PRINTING,
  GENERATE_ID_CARDS,
  GENERATE_SINGLE_ID_CARD,
  GET_CARD_BATCHES,
  GET_ID_CARDS_LIST,
  MARK_BATCH_PRINTED,
  MARK_ID_CARD_PRINTED,
  UPDATE_CARD_STATUS,
  UPLOAD_CANDIDATES_ASSETS_STATUS_FILE,
} from "helpers/url_helper"

export const uploadAssetsStatusFile = createAsyncThunk(
  UPLOAD_CANDIDATES_ASSETS_STATUS_FILE,
  async payload => {
    const response = await formDataPost(
      UPLOAD_CANDIDATES_ASSETS_STATUS_FILE,
      payload
    )
    return response
  }
)

export const generateIdCards = createAsyncThunk(
  GENERATE_ID_CARDS,
  async payload => {
    const response = await post(GENERATE_ID_CARDS, payload)
    return response
  }
)

export const generateSingleIDCard = createAsyncThunk(
  GENERATE_SINGLE_ID_CARD,
  async payload => {
    const response = await post(GENERATE_SINGLE_ID_CARD, payload)
    return response
  }
)

export const markBatchPrinted = createAsyncThunk(
  MARK_BATCH_PRINTED,
  async payload => {
    const response = await post(MARK_BATCH_PRINTED, payload)
    return response
  }
)

export const markIdCardPrinted = createAsyncThunk(
  MARK_ID_CARD_PRINTED,
  async payload => {
    const response = await post(MARK_ID_CARD_PRINTED, payload)
    return response
  }
)

export const updateCardStatus = createAsyncThunk(
  UPDATE_CARD_STATUS,
  async payload => {
    const response = await post(UPDATE_CARD_STATUS, payload)
    return response
  }
)

export const customBatchPrinting = createAsyncThunk(
  CUSTOM_BATCH_PRINTING,
  async payload => {
    const response = await post(CUSTOM_BATCH_PRINTING, payload, {
      responseType: "blob",
    })
    return response
  }
)

export const getIdCardsList = createAsyncThunk(
  GET_ID_CARDS_LIST,
  async payload => {
    const response = await post(GET_ID_CARDS_LIST, payload)
    return response
  }
)

export const getCardBatches = createAsyncThunk(
  GET_CARD_BATCHES,
  async payload => {
    const response = await post(GET_CARD_BATCHES, payload)
    return response
  }
)
